import axios from 'axios'
import {ready} from './shared'

function requireAll (r) {
  r.keys().forEach(r)
}

requireAll(require.context('./assets/icons-svg/', true, /\.svg$/))

ready(function () {
  const svgIconsElement = document.getElementById('svg-icons')
  if (!svgIconsElement) {
    return
  }

  const svgIconsFilePath = `${svgIconsElement.getAttribute('data-svg-icons-path')}`
  axios.get(svgIconsFilePath).then(response => {
    svgIconsElement.innerHTML = response.data
  })
})



// WEBPACK FOOTER //
// ./src/svg-icons-sprites.js